// extracted by mini-css-extract-plugin
export default {"box":"BorderedBox_box__4QSxF","title":"BorderedBox_title__h+FT+"};